import styled from '@emotion/styled';
import { Select } from '../../../../../components-dummy';

export const SelectDataFieldStyled = styled(Select)`
  width: 330px;
`;
